
const ENUM_TO_TEXT_MAP = {
  serviceUnitType: {
    HOURLY: 'Hourly',
    DAILY: 'Daily',
    VISIT: 'Visit',
    FLAT: 'Flat',
  },

  unbillableReason: {
    MISSING_AUTHORIZATION: 'Missing authorization',
    UNCONFIRMED: 'Unconfirmed',
    INVOICED: 'Invoiced',
    MISSED: 'Missed',
  },

  applyStatus: {
    PROCESSING: 'Processing',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    CANCELED: 'Canceled',
    ON_HOLD: 'On Hold',
    DISCHARGED: 'Discharged',
  },

  authPeriod: {
    DAY: 'Day',
    WEEK: 'Week',
    ENTIRE_PERIOD: 'Entire Period',
  },
};

export default {
  toText(type, enumValue) {
    return enumValue in ENUM_TO_TEXT_MAP[type] ? ENUM_TO_TEXT_MAP[type][enumValue] : enumValue;
  },
};
